module.exports = __webpack_public_path__ + "img/website-05.1978d1e8.png";